import { Fragment } from 'react';
import styled from 'styled-components';
import { getFieldValueKey } from '../../../utils/analytics/events/filter/utils';
import {
  ISimplePredicateFieldsFragment,
  RelationalOperatorKey,
} from '../../../utils/apollo/graphqlSchema';
import { FormulaLabel } from '../../ChipLabels';

const Predicate = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 4px;
`;

const Content = styled.div`
  flex: 0 0 auto;
  font-weight: 500;
`;

const Operands = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
`;
const StyledOperandValue = styled(FormulaLabel)`
  flex: 0 0 auto;
  padding: 1px 3px;
  border-radius: 2px;
  word-break: break-word;
  font-size: inherit;
  line-height: inherit;
`;

interface IProps {
  predicate: ISimplePredicateFieldsFragment;
  index: number;
}

export default ({ predicate, index }: IProps) => {
  const renderOperandValue = (
    operandName: string,
    operandTypeIsField: boolean,
  ) => {
    return (
      <StyledOperandValue $variant={operandTypeIsField ? 'purple' : 'blue'}>
        {operandName}
      </StyledOperandValue>
    );
  };

  return (
    <>
      {predicate.relOp.key === RelationalOperatorKey.Between ? (
        <Predicate>
          {renderOperandValue(
            predicate.operands.__typename === 'FieldOperands'
              ? predicate.operands.fields[0].name
              : predicate.operands.values[0].name,
            predicate.operands.__typename === 'FieldOperands',
          )}
          <Content>≤</Content>
          <Content>{predicate.field.name}</Content>
          <Content>≤</Content>
          {renderOperandValue(
            predicate.operands.__typename === 'FieldOperands'
              ? predicate.operands.fields[1].name
              : predicate.operands.values[1].name,
            predicate.operands.__typename === 'FieldOperands',
          )}
        </Predicate>
      ) : (
        <Predicate>
          <Content>{predicate.field.name}</Content>
          <Content>{predicate.relOp.name}</Content>
          <Operands>
            {predicate.operands.__typename === 'FieldOperands' &&
              predicate.operands.fields.map((field, fieldIndex) => {
                return (
                  <Fragment key={field.key + index + '-' + fieldIndex}>
                    {fieldIndex > 0 && <Content>and</Content>}
                    {field.name}
                  </Fragment>
                );
              })}
            {predicate.operands.__typename === 'ValueOperands' &&
              predicate.operands.values.map((value, valueIndex) => {
                const valueKey = getFieldValueKey(value);
                const valueName = value.name;
                return (
                  <Fragment key={valueKey + index + '-' + valueIndex}>
                    {valueIndex > 0 && <Content>and</Content>}
                    {valueName}
                  </Fragment>
                );
              })}
          </Operands>
        </Predicate>
      )}
    </>
  );
};
